import { Component, OnInit, ViewChild } from '@angular/core';
import { Content, NavController, NavParams } from 'ionic-angular';
import { ResumeService } from '../../../../../UI/src/app/shared/resume/resume.service';

@Component({
  selector: 'component-edit-profile',
  templateUrl: 'edit-profile.component.html'
})
export class EditProfileComponent implements OnInit {
  @ViewChild(Content) content: Content;
  public tabSelected = 'profile';
  public resumeAction: any; 
  public editResume: boolean = false;
  public createResume: boolean = false;
  public reviewResume: boolean = false;
  public isInititalCreation: boolean = false;

  constructor(
    public navParams: NavParams,
    public navCtrl: NavController,
    public resumeService: ResumeService,
  ) {
    this.resumeAction = this.resumeService.getResumeAction();    
    this.isInititalCreation = this.resumeAction.isInititalCreation;
    if (this.resumeAction.action == 'CREATE_RESUME') {
      this.createResume = true;
      this.editResume = false;
      this.reviewResume = false;
      this.tabSelected = 'resume';
    }
    else if (this.resumeAction.action == 'EDIT_RESUME') {
      this.createResume = false;
      this.editResume = true;
      this.reviewResume = false;
      if (this.navCtrl.last().name === 'CandidateProfileComponent') {
        this.tabSelected = 'profile';
      } else {
        this.tabSelected = 'resume';
      }
    }
    else if (this.resumeAction.action == 'REVIEW_RESUME') {
      this.createResume = false;
      this.editResume = false;     
      this.reviewResume = true;
      this.tabSelected = 'profile';
    }
  }

  ngOnInit() {    
  } 
}


// WEBPACK FOOTER //
// ./src/app/modules/edit-profile/edit-profile.component.ts